// extracted by mini-css-extract-plugin
export default {"Noti_Table":"Profile_Noti_Table__+Qhya","sigCanvas":"Profile_sigCanvas__4IAFT"};